{
  "invalidSelection": "Geselecteerde {selectedCount, plural, one {datum} other {datums}} niet beschikbaar."
}
